import * as commonFields from "./common-fields";
import type { BaseVendorDto } from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

export const manufacturerSchema: $ck.z.ZodType<BaseVendorDto> = $ck.z.object({
  name: commonFields.requiredStringField(),
  address1: commonFields.requiredStringField(),
  address2: commonFields.stringOrEmptyField(),
  address3: commonFields.stringOrEmptyField(),
  phone1: commonFields.requiredStringField(),
  phone2: commonFields.stringOrEmptyField(),
  fax: commonFields.stringOrEmptyField(),
  faxAttn: commonFields.stringOrEmptyField(),
  website: commonFields.stringOrEmptyField(),
  contact1: commonFields.requiredStringField(),
  title1: commonFields.requiredStringField(),
  email1: commonFields.requiredStringField(),
  contact2: commonFields.stringOrEmptyField(),
  title2: commonFields.stringOrEmptyField(),
  email2: commonFields.stringOrEmptyField(),
  note1: commonFields.requiredStringField(),
  keywords: commonFields.stringOrEmptyField(),
  corp: commonFields.requiredStringField(),
  active: commonFields.booleanField(),
  currency: commonFields.requiredStringField(),
});

export type ManufacturerSchema = $ck.z.TypeOf<typeof manufacturerSchema>;
